module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAEFCu8CAAAAAXNSR0IArs4c6QAAAVJJREFUSA3tVrFOwzAQfRfKRgeGVurAyga/gCoxsvMHLLDwI6x8CRsIfgEydq9Qt4IyUnO25SjBviOxRFSJZvHl3d17l7PPLfDjIftu3iYm4EUwwjpyBtFnAForibkjNHK8zCNqGTqHwyxZVENTIaqn6VRtMg097OOYzrAIGa26A+hWokrVzHdyJ2nJXztu6dmXTXETYV0B371y+tE1wcV94Vptu0j2W3vERHaorfuTRI10y3z2uC65plmirorH5SCBO4hMOV2zVc+TFFjjBms6XR3xeTRjHsnuifBnd/h93CnWmxcbfNMWV7yXd7FLQAz63RYCzXCwv6uecYkN7vnIHqrSxBEGr9jDLc3xosYKTi/4xHL95sPSPfC0Xgi8IuwFy0mOoEiadBC908lqlj1SSVIddL94Qwq6cnaC+q5keP9NS6nK6E7flPRf6r4sWx//DT+7RjyVpUryAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/btn_file.png
// module id = VoXk
// module chunks = 0